module.exports = __webpack_public_path__ + "img/search.ce47d904.svg";